module.exports = __webpack_public_path__ + "site/img/167.6f1dd0ae.jpg";